import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { environment } from 'src/environments/environment';
import { GetTemporaryPanelVideoUrlResponse } from '../../responses/panel/get-temporary-panel-video-url.response';

@Injectable({
  providedIn: 'root'
})

export class PanelToPanelTokenService extends CommonService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getVideoUrl(idPanel: number, expirationTimInHours: number): Observable<GetTemporaryPanelVideoUrlResponse> {

    let uri = `PanelToPanelToken/GetVideoUrl/idPanel/${idPanel}/expirationTimInHours/${expirationTimInHours}`;

    return this.httpClient.get<GetTemporaryPanelVideoUrlResponse>(environment.urlApiPanel + uri, this.addHeaderPanelToken())
      .pipe(
        catchError(this.handleError)
      )
  }  

  public getColors(idPanel: number): Observable<GetTemporaryPanelVideoUrlResponse> {

    let uri = `PanelToPanelToken/GetColors/idPanel/${idPanel}`;

    return this.httpClient.get<GetTemporaryPanelVideoUrlResponse>(environment.urlApiPanel + uri, this.addHeaderPanelToken())
      .pipe(
        catchError(this.handleError)
      )
  }  
}